<template>
    <div class="nodata">
        <Icon class="img" type="ios-hand" size="20"/>
        <div>{{$t('search_nodata')}} <span v-if="$base.getLang() != 'zh-TW'">[<Time :time="last_time" />]</span></div>
    </div>
</template>

<script>
    export default {
        props:{
            last_time: {
                default: false,
                type: Date,
            }
        }
    }
</script>

<style scoped>
    .nodata{
        text-align: center;
        padding: 10px;
        color: #888;
        font-size:12px;
    }
    .nodata .img{
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/myNodata.vue